var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._m(0),_vm._v(" "),_c('author-info',{attrs:{"suggestions":_vm.suggestions,"keyword":_vm.searchKeyword},on:{"update:keyword":function($event){_vm.searchKeyword=$event},"search":_vm.handleSearch}}),_vm._v(" "),_c('all-blogposts',{attrs:{"func":_vm.func}})],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('header',{attrs:{"id":"blog-header"}},[_c('div',{staticClass:"inner"})])
}]

export { render, staticRenderFns }